module.exports = __webpack_public_path__ + "img/app_coaches_top.7b6b360b.jpg";